import { render } from "./SettingsSidebar.vue?vue&type=template&id=00890a3c"
import script from "./SettingsSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsSidebar.vue?vue&type=script&lang=js"

import "./SettingsSidebar.vue?vue&type=style&index=0&id=00890a3c&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__